import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

// Generate or retrieve a visitor ID from localStorage
const getVisitorId = (): string => {
  const storageKey = 'visitor_id';
  let visitorId = localStorage.getItem(storageKey);
  
  if (!visitorId) {
    visitorId = crypto.randomUUID();
    localStorage.setItem(storageKey, visitorId);
  }
  
  return visitorId;
};

// Debounce to avoid logging multiple visits in quick succession
let lastLoggedPath: string | null = null;
let lastLoggedTime = 0;
const DEBOUNCE_MS = 5000; // 5 seconds between logs for same page

export const usePageVisit = (pagePath?: string) => {
  useEffect(() => {
    const path = pagePath || window.location.pathname;
    const now = Date.now();
    
    // Skip if same page was logged recently
    if (lastLoggedPath === path && now - lastLoggedTime < DEBOUNCE_MS) {
      return;
    }
    
    const logVisit = async () => {
      try {
        const visitorId = getVisitorId();
        
        await supabase.from('page_visits').insert({
          page_path: path,
          visitor_id: visitorId,
        });
        
        lastLoggedPath = path;
        lastLoggedTime = now;
      } catch (error) {
        // Silently fail - visitor tracking shouldn't break the app
        console.debug('Failed to log page visit:', error);
      }
    };
    
    logVisit();
  }, [pagePath]);
};
